import { IntlShape } from 'react-intl';

import { TPartnerType, RUPartnerType } from '../modules/partner/model/partnerType';

// right now required only for RU
const getLocalizedPartnerType = (partnerType: TPartnerType, intl: IntlShape): string => {
  switch (partnerType) {
    case RUPartnerType.ip:
      return intl.formatMessage({
        defaultMessage: 'Individual Entrepreneur',
        id: 'gAtqKc',
        description: 'Partner type',
      });

    case RUPartnerType.ooo:
      return intl.formatMessage({
        defaultMessage: 'Legal entity',
        id: 'rKrfYb',
        description: 'Partner type',
      });

    case RUPartnerType.selfEmployed:
      return intl.formatMessage({
        defaultMessage: 'Self-Employed',
        id: 'nN5R1C',
        description: 'Partner type',
      });

    default:
      return partnerType;
  }
};

export { getLocalizedPartnerType };
